"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.winterCalculation = void 0;
var is_leap_1 = require("../leap/is-leap");
function winterCalculation(gYear, days) {
    var year = 0, month = 0, day = 0;
    // year calculation
    year = gYear - 622;
    var dayDiffrence;
    if (is_leap_1.isLeap(gYear - 1)) {
        dayDiffrence = 11;
    }
    else {
        dayDiffrence = 10;
    }
    var leftOver = (days + dayDiffrence) % 30;
    if (leftOver === 0) {
        month = Math.floor((days + dayDiffrence) / 30) + 9;
        day = 30;
    }
    else {
        month = Math.floor((days + dayDiffrence) / 30) + 10;
        day = leftOver;
    }
    return { year: year, month: month, day: day };
}
exports.winterCalculation = winterCalculation;
